<template>
  <CustomRow>
    <v-card height="574" class="mt-5 text-center cusPadding">
      <SendEmailForm :email="email" />
    </v-card>
  </CustomRow>
</template>

<script>
import SendEmailForm from "@/views/auth/components/SendEmailForm.vue";

export default {
  components: { SendEmailForm },
  computed: {
    email() {
      return this.$route.params.email || "";
    }
  }
};
</script>

<style lang="scss" scoped>
.cusPadding {
  padding: 80px 20px;
}
</style>
